/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { compose } from "./compose.js";
import { invert } from "./invert.js";
import { prune } from "./prune.js";
import { rebase } from "./rebase.js";
import { replaceRevisions } from "./replaceRevisions.js";
export const sequenceFieldChangeRebaser = {
    compose,
    invert,
    rebase,
    prune,
    replaceRevisions,
};
//# sourceMappingURL=sequenceFieldChangeRebaser.js.map